import { __assign } from 'tslib';
import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

var PREFIX = "BasketLayout";
var classes = {
    loadingContainer: "".concat(PREFIX, "-loadingContainer"),
    container: "".concat(PREFIX, "-container"),
    loading: "".concat(PREFIX, "-loading"),
    header: "".concat(PREFIX, "-header"),
    basketInfo: "".concat(PREFIX, "-basketInfo"),
    basketSelectInput: "".concat(PREFIX, "-basketSelectInput"),
    basketSelectInputLabel: "".concat(PREFIX, "-basketSelectInputLabel"),
    basketCount: "".concat(PREFIX, "-basketCount"),
    actionsContainer: "".concat(PREFIX, "-actionsContainer"),
    paginationContainer: "".concat(PREFIX, "-paginationContainer"),
    basketElements: "".concat(PREFIX, "-basketElements")
};
var StyledBasketLayout = styled(Box, {
    shouldForwardProp: function (prop) { return prop !== "active"; }
})(function (_a) {
    var _b, _c, _d, _e;
    var theme = _a.theme, active = _a.active;
    return (__assign(__assign((_b = { zIndex: 1, position: "relative", backgroundColor: theme.palette.grey[100], height: "100%", width: 0, transitionProperty: "width", 
            // Material UI Recommand a 250ms for opening and 200ms for closing
            // https://material.io/design/motion/speed.html#duration
            transitionDuration: active ? ".25s" : ".2s", transitionTimingFunction: "ease-out" }, _b[theme.breakpoints.up("xs")] = {
        maxWidth: "75vw"
    }, _b[theme.breakpoints.up("sm")] = {
        maxWidth: "30vw"
    }, _b[theme.breakpoints.up("md")] = {
        maxWidth: "25vw"
    }, _b), (active && (_c = {
            width: theme.spacing(50)
        },
        _c[theme.breakpoints.up("sm")] = {
            minWidth: theme.spacing(35)
        },
        _c[theme.breakpoints.up("md")] = {
            minWidth: theme.spacing(40)
        },
        _c))), (_d = {}, _d["& .".concat(classes.loadingContainer)] = {
        position: "relative"
    }, _d["& .".concat(classes.container)] = {
        width: "100%",
        overflowX: "hidden",
        display: "grid",
        height: "100%",
        gridTemplateRows: "min-content min-content min-content 1fr",
        gridTemplateAreas: "\"header\" \"info\" \"pagination\" \"elements\"",
        // Simulate a small shadow with a slight border
        borderLeft: "1px solid rgba(0,0,0,0.1)"
    }, _d["& .".concat(classes.loading)] = {
        position: "absolute",
        width: "100%"
    }, _d["& .".concat(classes.header)] = {
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
        height: theme.spacing(8),
        maxHeight: "10vh",
        alignItems: "center",
        gridArea: "header",
        display: "grid",
        gridTemplateColumns: "auto min-content",
        gap: theme.spacing(1),
        button: {
            whiteSpace: "nowrap"
        }
    }, _d["& .".concat(classes.basketInfo)] = {
        backgroundColor: "#fff",
        padding: theme.spacing(2),
        width: "100%",
        display: "flex",
        justifyContent: "space-between",
        gridArea: "info",
        position: "relative",
        zIndex: 1
    }, _d["& .".concat(classes.basketSelectInputLabel)] = {
        backgroundColor: theme.palette.grey[100],
        color: theme.palette.text.primary
    }, _d["& .".concat(classes.basketCount)] = {
        whiteSpace: "nowrap",
        gridArea: "count",
        marginLeft: theme.spacing(0.5),
        display: "flex",
        alignItems: "center"
    }, _d["& .".concat(classes.actionsContainer)] = {
        display: "block",
        textAlign: "left",
        gridArea: "actions"
    }, _d["& .".concat(classes.paginationContainer)] = (_e = {
            gridArea: "pagination",
            display: "flex",
            justifyContent: "center"
        },
        _e["& + .".concat(classes.basketElements)] = {
            paddingTop: theme.spacing(2)
        },
        _e), _d["& .".concat(classes.basketElements)] = {
        paddingTop: theme.spacing(4),
        overflow: "auto",
        gridArea: "elements"
    }, _d)));
});

export { classes, StyledBasketLayout as default };
//# sourceMappingURL=index.styled.js.map
